exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "covance-side-nav ::ng-deep .icon-img {\n  padding-right: 10px !important;\n}\n\n", ""]);

// exports
